import {BaseContainerModel} from '../base-container.model';
import { bl_fi_xtn_generic_doc_hdr_RowClass, bl_fi_xtn_generic_doc_hdr_RowInterface } from '../../dbschema/bl_fi_xtn_generic_doc_hdr.model';
import { bl_fi_xtn_generic_doc_line_RowClass } from '../../dbschema/bl_fi_xtn_generic_doc_line.model';

export class ExternalGenericDocContainerModel extends BaseContainerModel {
  bl_fi_xtn_generic_doc_hdr: bl_fi_xtn_generic_doc_hdr_RowInterface = new bl_fi_xtn_generic_doc_hdr_RowClass();
  bl_fi_xtn_generic_doc_lines: bl_fi_xtn_generic_doc_line_RowClass[] = [];
}
